import { User } from './user.model'
import * as moment from 'moment'
moment.locale('fr')

export interface ICommentRequestData {
  id: string
  eventId: string
  body: string
  authorId: string
}

export class Comment {
  public id = ''
  public eventId = ''
  public body = ''
  public createdAt: moment.Moment = null
  public updatedAt: moment.Moment = null
  public author = new User()

  cast (data: Object) {
    Object.keys(data).forEach((key) => {
      if (this.hasOwnProperty(key)) {
        switch (key) {
          case 'author':
            const role: string = data[key]
            this[key] = new User().cast(data[key])
            break
          default:
            this[key] = data[key]
            break
        }
      }
    })

    return this
  }

  toRequestData (): ICommentRequestData {
    return {
      id: this.id,
      eventId: this.eventId,
      body: this.body,
      authorId: this.author.id
    }
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/models/comment.model.ts